import { createModel } from "@rematch/core";
import type { RootModel } from ".";
import { PaginationFactory } from "../factory";
import { ScheduleType } from "../types/schedule.types";


export interface ScheduleStoreProps {
    pagination: PaginationFactory<ScheduleType.Model>;
    loading: {
        fetchMany: boolean;
        updateSchedule: boolean;
        createSchedule: boolean;
        fetchById: boolean;
    };
    selectedSchedule: ScheduleType.Model | null;
}

export const scheduleInitialState: ScheduleStoreProps = {
    pagination: {} as PaginationFactory<ScheduleType.Model>,
    loading: {
        fetchMany: false,
        updateSchedule: false,
        createSchedule: false,
        fetchById: false,
    },
    selectedSchedule: null,
};

export const schedules = createModel<RootModel>()({
    state: scheduleInitialState,
    reducers: {
        toggleLoading: (store, prop: keyof ScheduleStoreProps["loading"], v: boolean) => {
            return {
                ...store,
                loading: {
                    ...store.loading,
                    [prop]: v,
                },
            };
        },
        setPagination: (store, pagination: PaginationFactory<ScheduleType.Model>) => {
            return {
                ...store,
                pagination,
            };
        },
        setSelectedSchedule: (store, schedule: ScheduleType.Model | null) => {
            console.log('new schedule store', schedule)
            return {
                ...store,
                selectedSchedule: schedule,
            };
        },
    },
});
